import {useEffect} from "react";
import {setIconsStyle} from "../../features/projectSlice";
import {setCssProp, themes} from "../settings/ThemeChanger";
import {useAppDispatch} from "../../hooks";
import moment from "moment/moment";

const currentSettingsVersion = 6

export default function useTheme() {

    const dispatch = useAppDispatch();

    useEffect(() => {

        let version = localStorage.getItem('theme-version');
        if (version === null || Number(version) < currentSettingsVersion) {
            localStorage.setItem('theme-version', currentSettingsVersion.toString())
            localStorage.removeItem('theme')
            localStorage.removeItem('primary-color')
            localStorage.removeItem('iconStyle')
        }

        let themeKey = localStorage.getItem('theme') || 'classic';
        let color = localStorage.getItem('primary-color') || '#089DF8';
        // localStorage.getItem('iconStyle') || 'fontAwesome';
        let icons = 'fontAwesome';

        let tdPadding: any = localStorage.getItem('td-padding');
        tdPadding = parseInt(tdPadding || "6");
        if (isNaN(tdPadding))
            tdPadding = 6
        setCssProp("--td-padding", tdPadding * 2 + 'px')

        dispatch(setIconsStyle(icons))

        if (themeKey && themes[themeKey]) {
            Object.entries(themes[themeKey].values).forEach(([prop, val]) => {
                setCssProp('--' + prop, val)
            })
        }
        if (color)
            setCssProp('--table-action-color', color)

        moment.locale('uk')


    }, [dispatch]);

}
